<template>
  <div :class="pb" class="relative bg-thumb">
    <img :src="blank" :data-src="src" :class="classes" class="absolute w-full h-full"/>
  </div>
</template>

<script>
import { mdImg } from '@/utils'

export default {
  name: 'BaseBgImage',
  props: {
    image: {
      type: Object,
      required: true
    },
    ratio: {
      type: String,
      default: '3/4'
    },
    cover: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      blank: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
      rendered: false
    }
  },
  computed: {
    src () {
      if (!this.rendered) return
      if (!this.image.sizes) return this.mdImg(this.image)
      const w = this.$el.clientWidth

      // return scaled size
      const s = w > 1400 ? 'original' : w > 800 ? 'lg' : 'md'

      return this.image.sizes[s].src
    },
    pb () {
      return `pb-${this.ratio}`
    },
    classes () {
      return [
        this.rendered && 'lazyload',
        this.cover ? 'object-cover' : 'object-contain'
      ]
    }
  },
  methods: {
    mdImg
  },
  mounted () {
    this.rendered = true
  }
}
</script>
